import InputTypes from 'utils/enums/inputTypes';
import { IField } from 'utils/interfaces/IField';

const subjectGroup: IField[] = [
    {
        presentation: 'Nome',
        label: 'Nome',
        name: 'name',
        type: InputTypes.text,
        columns: 3
    }
];

export default subjectGroup;
